import { Component, ChangeDetectionStrategy, Inject, OnInit } from '@angular/core';
import { SidePanelRef } from '../../../../shared/features/side-panel/models/side-panel-ref';
import { SIDE_PANEL_CONTEXT } from '../../../../shared/features/side-panel/tokens/side-panel.tokens';
import { EditResumePanelComponent } from '../edit-resume-panel/edit-resume-panel.component';

export interface EditUserPanelData {
  userId: number;
  currentName: string;
}

export interface EditUserPanelResult {
  newName: string;
}

@Component({
  selector: 'app-edit-user-panel',
  templateUrl: './edit-user-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditUserPanelComponent implements OnInit {
  userName: string;

  constructor(
    @Inject(SIDE_PANEL_CONTEXT) public panelRef: SidePanelRef<EditUserPanelData, EditUserPanelResult>
  ) { }

  ngOnInit(): void {
    this.userName = this.panelRef.data.currentName;
  }

  goToNextStep(): void {
    const updatedUserData = {
      userId: this.panelRef.data.userId,
      newName: this.userName,
    };
    
    this.panelRef.navigateForward(EditResumePanelComponent, updatedUserData);
  }

  cancel(): void {
    this.panelRef.dismiss();
  }
}